<template>
  <div>
    <div class="TagsFather">
      <ModelDiv class="ModelDiv"></ModelDiv>
      <el-tabs v-model="activeNames" @tab-click="handleClick">
        <el-tab-pane v-for="items in ListGroup" :label="items.modelType" style="overflow: auto;width: 100vw;"
          :key="items.modelTypeFlag" :name="items.modelTypeFlag" class="TabStyle" :id="items.modelTypeFlag">
          <div class="item">
            <div @click="ModelOpacityChange" v-for="(item, index) in listnames" :key="item.modelUuid" :id="item.modelId"
              class="TagsItem" :style="{ border: `3px solid rgb(${item.modelColor})` }"
              v-if="items.modelTypeFlag == item.modelTypeFlag">
              <div style="pointerEvents : none" class="modelName">{{ item.modelName }}</div>
              <div class="el-icon-view modelHide" @click.stop="eyesHide(item, index)"
                style="display: block;font-size: 25px;cursor: pointer; width: 25px; margin: 4px auto;"
                v-if="icons[index]"></div>
              <div class=" modelHide" v-else @click.stop="eyesHide(item, index)"
                style="display: block;font-size: 25px;cursor: pointer; width: 25px;height: 25px; margin: 4px auto;"><img
                  src="/static/images/eye-blocked.png" style="width: 25px;height: 23px;" alt=""></div>
              <div class="ColorSelector12" :style="{ background: ` rgb(${item.modelColor})` }"
                @click.stop="ModelBackColorChange"></div>
              <p style="pointerEvents : none" class="modelSize">{{ item.modelSize }}ML</p>
              <button style="pointerEvents : none">状态:{{ item.modelOpacity * 100 }}%</button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <ColorSelector v-show="selectedChange" class="ColorSelectors" :mess="Modelsid"></ColorSelector>
  </div>
</template>
<script>
import ColorSelector from "@/views/ColorSelector/ColorSelector.vue";
import ModelDiv from "@/views/ModelDiv/ModelDiv.vue";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
export default {
  components: {
    ColorSelector,
    ModelDiv
  },
  data() {
    return {
      WindowWidth: screen.width,
      activeNames: "1",
      listnames: [],
      MeshsChid: null,
      ListColor: null,
      selectedChangeColosBool: false,
      previousDiv: null,
      // 分组信息
      ListGroup: this.$store.state.groupInfo,
      ids: null,
      Modelsid: null,
      opacity: null,
      modelTypeFlags: null,
      flag: false,
      icons: []
    };
  },
  watch: {
    activeTabName(news, old) {
      this.activeNames = news;
      const targetDiv = document.getElementById('tab-' + news)
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    },
    labelEyes(news, old) {
      if (news == 4) return
      if (news == 1) {
        this.icons = []
        this.listnames.forEach(item => {
          item.icons = true
          this.icons.push(item.icons)
        })
      } else if (news == 2) {
        this.icons = []
        this.listnames.forEach(item => {
          item.icons = true
          this.icons.push(item.icons)
        })
      } else if (news == 3) {
        this.icons = []
        this.listnames.forEach(item => {
          item.icons = false
          this.icons.push(item.icons)
        })
      }
      this.setLabelEyes(4)
    },
  },
  computed: { ...mapState(["activeTabName", "labelEyes", "modelVisible", "selectedChange", "targetDivHtml"]), },
  methods: {
    ...mapMutations(["setLabelEyes", "setActiveMeshId", "setSelectedChange", "setTargetDivHtml", "setEyeDisplay", "setModelVisible", "setActiveModelName"]),
    //  颜色选择
    ModelBackColorChange(e) {
      this.Modelsid = e.target.parentNode.id
      const SelectCOlor = this.$store.state.selectedChange
      this.setSelectedChange(!SelectCOlor);
    },
    eyesHide(e, index) {
      this.icons.splice(index, 1, !this.icons[index]);
      this.MeshsChid.forEach(item => {
        if (item.model_id == e.modelId) {
          if (!this.icons[index]) {
            item.material.opacity = 0;
            item.visible = false;
            document.getElementById(item.model_id).childNodes[4].innerText = `状态:${item.material.opacity * 100}%`
            item.material.depthWrite = true
            return
          }
          item.visible = true;
          item.material.transparent = true;
          item.material.opacity = 0.5;
          item.material.depthWrite = false

          document.getElementById(item.model_id).childNodes[4].innerText = `状态:${item.material.opacity * 100}%`
          return
        }
      })
    },
    async handleClick(tab, event) {
      this.addStyle(tab._props.name);
      const modelTypeFlag = event.target.id.slice(-1);
      // 只有再次点击同一个 tab 才触发透明度轮换
      if (modelTypeFlag === this.modelTypeFlags) {
        let modelId = [];
        this.listnames.forEach(item => {
          if (item.modelTypeFlag == modelTypeFlag) {
            modelId.push(item.modelId);
          }
        });

        // 定义透明度状态循环：0.25 → 0.45 → 1 → 0 → 回到 0.25
        const states = [0.25, 0.5, 1, 0];
        let nextOpacity = 0.25; // 默认从 0.25 开始
        // 获取任意一个关联模型的当前 opacity 作为参考
        const sampleMesh = this.MeshsChid.find(m => m.model_id === modelId[0]);
        if (sampleMesh) {
          const currentOpacity = sampleMesh.material.opacity;
          const isVisible = sampleMesh.visible;
          // 如果不可见且 opacity 为 0，则视为“0”状态
          let normalizedOpacity = !isVisible && currentOpacity === 0 ? 0 : currentOpacity;

          // 查找当前处于哪个状态，并决定下一个
          for (let i = 0; i < states.length; i++) {
            if (Math.abs(normalizedOpacity - states[i]) < 0.01) {
              const nextIndex = (i + 1) % states.length;
              nextOpacity = states[nextIndex];
              break;
            }
          }
        }
        // 应用新透明度到所有相关模型
        this.MeshsChid.forEach((item) => {
          if (modelId.includes(item.model_id)) {
            const nameIndex = this.listnames.findIndex(n => n.modelId === item.model_id);
            if (nextOpacity === 0) {
              item.visible = false;
              item.material.opacity = 0;
              item.material.transparent = false;
              item.material.depthWrite = false;
              if (nameIndex !== -1) this.icons.splice(nameIndex, 1, false);
            } else if (nextOpacity === 1) {
              item.visible = true;
              item.material.opacity = nextOpacity;
              item.material.transparent = false;
              item.material.depthWrite = true
              item.material.needsUpdate = true;
              if (nameIndex !== -1) this.icons.splice(nameIndex, 1, true);
            } else {
              item.visible = true;
              item.material.opacity = nextOpacity;
              item.material.transparent = true;
              item.material.depthWrite = false
              if (nameIndex !== -1) this.icons.splice(nameIndex, 1, true);
            }

            // 更新 DOM 上的文字显示
            const el = document.getElementById(item.model_id);
            if (el && el.childNodes[4]) {
              const displayValue =
                nextOpacity === 0
                  ? "0%"
                  : `${Math.round(nextOpacity * 100)}%`;
              el.childNodes[4].innerText = `状态:${displayValue}`;
            }

            // 同步更新 listnames 中的 modelOpacity（用于模板响应式显示）
            const nameItem = this.listnames.find(n => n.modelId === item.model_id);
            if (nameItem) {
              nameItem.modelOpacity = nextOpacity;
            }
          }
        });
      }

      // 记录本次 tab 标识
      this.modelTypeFlags = modelTypeFlag;
    },
    ModelOpacityChange(e) {
      const ModelDisplayAndHidings = true;
      let count = 1;
      this.MeshsChid.forEach((item) => {
        if (item.visible) {
          count++;
        }
      });
      if (count == this.MeshsChid.length) {
        this.setEyeDisplay(ModelDisplayAndHidings);
        this.setModelVisible(ModelDisplayAndHidings);
      }

      let id = e.currentTarget.id;
      const targetDiv = document.getElementById(id);
      const clickedItem = this.listnames.find(item => item.modelId === id)
      if (clickedItem) { this.setActiveModelName(clickedItem.modelName) }
      const modelIdid = this.$store.state.listColor;
      modelIdid.forEach((item) => {
        if (document.getElementById(item.modelId).classList[1]) {
          document.getElementById(item.modelId).classList.remove("active");
        }
      });

      if (targetDiv?.classList[1]) {
        targetDiv?.classList.remove("active");
      } else {
        targetDiv?.classList.add("active");
        this.setTargetDivHtml(targetDiv?.innerHTML);
      }

      if (this.ids == id) {
        targetDiv?.classList.add("active");
        this.setTargetDivHtml(targetDiv?.innerHTML);
      } else if (this.previousDiv) {
        this.previousDiv.classList.remove("active");
      }
      this.ids = id;
      this.previousDiv = targetDiv;

      const meshItem = this.MeshsChid.find(item => item.model_id === id);
      const nameIndex = this.listnames.findIndex(item => item.modelId === id);

      if (!meshItem) return;

      // 定义透明度状态序列
      const opacityStates = [0, 0.25, 0.5, 1];
      const currentOpacity = meshItem.material.opacity;
      const isVisible = meshItem.visible;

      // 规范化当前状态（防止浮点误差或 visible 不一致）
      const normalizedOpacity = !isVisible || Math.abs(currentOpacity - 0) < 0.01 ? 0 : currentOpacity;

      // 查找下一个状态
      let currentIndex = opacityStates.findIndex(op => Math.abs(op - normalizedOpacity) < 0.01);
      const nextIndex = (currentIndex + 1) % opacityStates.length;
      const newOpacity = opacityStates[nextIndex];

      // 应用新状态
      if (newOpacity === 0) {
        meshItem.visible = false;
        meshItem.material.opacity = 0;
        meshItem.material.transparent = true;
        meshItem.material.depthWrite = false;
        if (nameIndex !== -1) this.icons.splice(nameIndex, 1, false);
        e.currentTarget.childNodes[4].innerText = `状态:${Math.round(newOpacity * 100)}%`;
      } else if (newOpacity === 1) {
        meshItem.visible = true;
        meshItem.material.opacity = 1;
        meshItem.material.transparent = false;
        meshItem.material.depthWrite = true;
        meshItem.material.needsUpdate = true;
        if (nameIndex !== -1) this.icons.splice(nameIndex, 1, true);
        e.currentTarget.childNodes[4].innerText = `状态:${Math.round(newOpacity * 100)}%`;
      } else {
        meshItem.visible = true;
        meshItem.material.opacity = newOpacity;
        meshItem.material.transparent = true;
        meshItem.material.depthWrite = false;
        if (nameIndex !== -1) this.icons.splice(nameIndex, 1, true);
        e.currentTarget.childNodes[4].innerText = `状态:${Math.round(newOpacity * 100)}%`;
      }



      const nameItem = this.listnames?.find(n => n.modelId === id);
      if (nameItem) {
        nameItem.modelOpacity = newOpacity;
      }

    },
    handleResize() { this.WindowWidth = screen.width; },
    async addStyle(tab_props_name) {
      const div = await document.getElementById(tab_props_name).children[0]
      if (this.WindowWidth <= 1000) {
        if (div.children.length <= 3) {
          div.style.justifyContent = "center"
        }
      } else {
        div.style.justifyContent = ""
      }
    }
  },
  mounted() {
    this.listnames = this.$store.state.listColor;
    this.listnames.forEach(item => {
      this.icons.push(item.icons)
    })
    this.MeshsChid = this.$store.state.meshList;
    this.addStyle(1)
    window.addEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="scss">
.TagsFather {
  position: relative;

  .ModelDiv {
    max-width: 200px;
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translate(-50%, -50%);

  }
}

.item {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin: 0 auto;
  width: 95vw;
}

/* .el-tab-pane{
    display: block !important;
  } */
.item::-webkit-scrollbar {
  background-color: #cce5ff;
  height: 12px;
  border-radius: 10px;
}

.item::-webkit-scrollbar-thumb {
  background-color: var(--color-main-menu);
  border-radius: 10px;
  height: 12px;
}

.el-tabs__header {
  margin: 0;
}

.el-tabs__nav-wrap {
  min-width: 100vw;
}

.el-tabs__nav {
  width: 20%;
}

@media (min-width: 1100px) {
  .el-tabs__nav {
    width: 6%;
  }
}

.el-tabs__active-bar {
  height: 0;
  width: 0 !important;
}

.el-tabs__item {
  color: #409eff !important;
  line-height: 30px;
  height: 30px;
  text-align: center;
  min-width: 100%;
  padding: 0 !important;
  margin-top: -1px;
  font-size: 16px !important;
  font-weight: bold !important;
}

.el-tabs__item.is-active {
  background-color: #409EFF;
  border-radius: 5px;
  font-size: 16px;
  color: var(--color-second-text) !important;
}

@media (min-width: 800px) and (max-width: 930px) {
  .item {
    display: flex;
    overflow: auto;
    margin: 0 auto;
    width: 95vw;
  }

  .TagsItem>.modelName {
    font-size: 16px;
    margin-top: 4px;
    color: var(--color-second-text);
    text-align: center;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 用省略号表示溢出内容 */
  }

  .TagsItem button {
    border-radius: 4px;
    background: transparent;
    font-size: 16px;
    outline: none;
    border: none;
    margin: 3px auto;
    color: var(--color-second-text);
    text-align: center;
    cursor: pointer;
    display: block;
  }

  .TagsItem .modelSize {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 400;
    margin-top: 4px;
    color: var(--color-second-text);
    text-align: center;
  }

  .TagsItem .ColorSelector12 {
    width: 60px;
    height: 25px;
    margin: 0 auto;
    border-radius: 5px;
  }

  .TagsItem {
    min-width: 100px;
    min-height: 135px;
    opacity: 1;
    border-radius: 7px;
    background: var(--color-bg-menu);
    color: var(--color-second-text);
    margin-right: 10px;
  }
}

.el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0 !important;
}

@media (min-width: 200px) and (max-width: 380px) {
  .TagsItem>.modelName {
    font-size: 14px;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 用省略号表示溢出内容 */
    color: var(--color-second-text);
    text-align: center;
    margin: 1px auto;
    /* overflow: hidden; */
    max-width: 70px;

  }

  .item {
    display: flex;
    overflow: auto;
    margin: 0 auto;
    width: 95vw;
  }

  .TagsItem button {
    border-radius: 4px;
    background: transparent;
    font-size: 14px;
    outline: none;
    border: none;
    margin: 3px auto;
    color: var(--color-second-text);
    text-align: center;
    cursor: pointer;
    display: block;
  }

  .TagsItem>.modelSize {
    margin-bottom: 4px;
    font-size: 13px;
    margin-top: 3px;
    color: var(--color-second-text);
    text-align: center;
  }

  .TagsItem .ColorSelector12 {
    width: 40px;
    height: 18px;
    border-radius: 5px;
    margin: 0 auto
  }

  .TagsItem {
    min-width: 80px;
    min-height: 120px;
    opacity: 1;
    border-radius: 7px;
    background: var(--color-bg-menu);
    color: var(--color-second-text);
    margin-right: 10px;
  }
}

@media (min-width: 931px) and (max-width: 1400px) {
  .item {
    display: flex;
    overflow: auto;
    margin: 0 auto;
    width: 95vw;
  }

  .TagsItem>.modelName {
    font-size: 14px;
    margin-top: 3px;
    color: var(--color-second-text);
    text-align: center;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 用省略号表示溢出内容 */
    max-width: 110px;

  }

  .TagsItem button {
    border-radius: 4px;
    background: transparent;
    font-size: 16px;
    outline: none;
    border: none;
    margin: 3px auto;
    color: var(--color-second-text);
    text-align: center;
    cursor: pointer;
    display: block;
  }

  .TagsItem>.modelSize {
    margin-bottom: 4px;
    font-size: 16px;
    margin-top: 3px;
    color: var(--color-second-text);
    text-align: center;
  }

  .TagsItem .ColorSelector12 {
    width: 50px;
    height: 23px;
    margin: 0 auto;
    border-radius: 5px;
  }

  .TagsItem {
    min-width: 115px;
    min-height: 140px;
    opacity: 1;
    border-radius: 7px;
    background: var(--color-bg-menu);
    color: var(--color-second-text);
    margin-right: 10px;
  }
}

@media (min-width: 1401px) {
  .item {
    display: flex;
    overflow: auto;
    margin: 0 auto;
    width: 95vw;
  }

  .TagsItem>.modelName {
    font-size: 16px;
    margin-top: 4px;
    color: var(--color-second-text);
    text-align: center;
    max-width: 100px;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 用省略号表示溢出内容 */
  }

  .TagsItem button {
    border-radius: 4px;
    background: transparent;
    font-size: 16px;
    font-weight: 400;
    outline: none;
    border: none;
    margin: 3px auto;
    color: var(--color-second-text);
    text-align: center;
    cursor: pointer;
    display: block;
  }

  .TagsItem>.modelSize {
    font-size: 16px;
    margin-top: 3px;
    margin-bottom: 2px;
    color: var(--color-second-text);
    text-align: center;
  }

  .TagsItem .ColorSelector12 {
    width: 45px;
    height: 18px;
    margin: 0 auto;
    border-radius: 5px;
  }

  .TagsItem {
    min-width: 100px;
    min-height: 135px;
    opacity: 1;
    border-radius: 7px;
    background: var(--color-bg-menu);
    color: var(--color-second-text);
    margin-right: 10px;
  }
}

@media (min-width: 390px) and (max-width: 800px) {
  .item {
    display: flex;
    overflow: auto;
    margin: 0 auto;
    width: 95vw;
  }

  .TagsItem>.modelName {
    font-size: 15px;
    margin: 1px auto;
    color: var(--color-second-text);
    text-align: center;
    /* white-space: nowrap; */
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 用省略号表示溢出内容 */
    max-width: 120px;
  }

  .TagsItem button {
    border-radius: 4px;
    background: transparent;
    font-size: 14px;
    outline: none;
    border: none;
    margin: 3px auto;
    color: var(--color-second-text);
    text-align: center;
    cursor: pointer;
    display: block;
  }

  .TagsItem>.modelSize {
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 4px;
    color: var(--color-second-text);
    text-align: center;
  }

  .TagsItem .ColorSelector12 {
    width: 50px;
    height: 20px;
    border-radius: 5px;
    margin: 0 auto
  }

  .TagsItem {
    min-width: 90px;
    min-height: 130px;
    opacity: 1;
    border-radius: 7px;
    background: var(--color-bg-menu);
    color: var(--color-second-text);
    margin-right: 10px;
  }
}

.el-tabs__nav-scroll {
  overflow: hidden !important;
  ;
  overflow-x: auto !important;

}

.el-tabs__nav-scroll::-webkit-scrollbar {
  display: none !important;
}

.ColorSelectors {
  position: fixed;
  top: 105px;
  left: 20px;
}

/* 模型卡片不压缩、名称完整显示，卡片过多时可横向滚动 */
.TagsItem {
  flex-shrink: 0;
}

.TagsItem > .modelName {
  max-width: none;
  overflow: visible;
}
</style>
